import router from '../router'
import {getAuthorizeUrl, isWechatBrowser} from '../utils/wx'

export default {
  beforeRouteEnter (to, from, next) {
    if (isWechatBrowser()) {
      window.location.href = getAuthorizeUrl()  // 获取微信认证地址
    } else {
      router.push({name: 'Login'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/wx-login.js